import gql from 'graphql-tag'

export const GENERATE_PRESIGNED_POST = gql`
  query generatePresignedPost($prefix: String!, $key: String!) {
    generatePresignedPost(prefix: $prefix, key: $key) {
      url
      fields
    }
  }
`
